export const brazilianStates = [
    {sigla: 'AC', nome: 'Acre'},
    {sigla: 'AL', nome: 'Alagoas'},
    {sigla: 'AP', nome: 'Amapá'},
    {sigla: 'AM', nome: 'Amazonas'},
    {sigla: 'BA', nome: 'Bahia'},
    {sigla: 'CE', nome: 'Ceará'},
    {sigla: 'DF', nome: 'Distrito Federal'},
    {sigla: 'ES', nome: 'Espírito Santo'},
    {sigla: 'GO', nome: 'Goiás'},
    {sigla: 'MA', nome: 'Maranhão'},
    {sigla: 'MT', nome: 'Mato Grosso'},
    {sigla: 'MS', nome: 'Mato Grosso do Sul'},
    {sigla: 'MG', nome: 'Minas Gerais'},
    {sigla: 'PA', nome: 'Pará'},
    {sigla: 'PB', nome: 'Paraíba'},
    {sigla: 'PR', nome: 'Paraná'},
    {sigla: 'PE', nome: 'Pernambuco'},
    {sigla: 'PI', nome: 'Piauí'},
    {sigla: 'RJ', nome: 'Rio de Janeiro'},
    {sigla: 'RN', nome: 'Rio Grande do Norte'},
    {sigla: 'RS', nome: 'Rio Grande do Sul'},
    {sigla: 'RO', nome: 'Rondônia'},
    {sigla: 'RR', nome: 'Roraima'},
    {sigla: 'SC', nome: 'Santa Catarina'},
    {sigla: 'SP', nome: 'São Paulo'},
    {sigla: 'SE', nome: 'Sergipe'},
    {sigla: 'TO', nome: 'Tocantins'},
];


export function formatDateString(dateString) {

    const dateObj = new Date(dateString);

    const newDateString = dateObj.toISOString();

    const year = newDateString.slice(0, 4);
    const month = newDateString.slice(5, 7);
    const day = newDateString.slice(8, 10);

    return `${day}/${month}/${year}`;
}

export function formatDateTimeString(dateString) {

    const dateObj = new Date(dateString);

    dateObj.setHours(dateObj.getHours() - 3);


    const newDateString = dateObj.toISOString();

    const year = newDateString.slice(0, 4);
    const month = newDateString.slice(5, 7);
    const day = newDateString.slice(8, 10);

    const hours = ('0' + dateObj.getHours()).slice(-2);
    const minutes = ('0' + dateObj.getMinutes()).slice(-2);

    return `${day}/${month}/${year} ${hours}:${minutes}`;

}

export function formatDateToAmericanFormat(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();

    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    return year + '-' + month + '-' + day;
}

export const normalizeDate = (date) => {
    const newDate = new Date(date.toISOString().split('T')[0]);
    return newDate;
};


export function formatDateToString(date) {

    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return day + '/' + month + '/' + year;
}

export function getYearMonthFormat(date) {

    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return month + '/' + year;
}

export function formatDateStringToString(dateStr) {
    const date = new Date(dateStr + 'T00:00:00');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}


export function formatDateTimeToString(date) {

    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
}

export function calculateDaysDifference(date1, date2) {
    var date1Millis = date1.getTime();
    var date2Millis = date2.getTime();
    var differenceMillis = date2Millis - date1Millis;
    var differenceInDays = Math.ceil(differenceMillis / (1000 * 60 * 60 * 24));
    return differenceInDays;
}

export function plusDays(date, days) {
    date = new Date(date);
    date.setDate(date.getDate() + days);
    return date;

}

export function removeTimeFromDate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

export function getDate(dateString) {

    const dateObj = new Date();
    dateObj.setUTCHours(0, 0, 0, 0);

    const newDateString = dateString;

    let year = newDateString.slice(0, 4);
    let month = Number(newDateString.slice(5, 7)) - 1;
    const day = newDateString.slice(8, 10);

    if (month === -1) {
        month = 12;
        year--;
    }

    dateObj.setFullYear(year, month, day);

    return dateObj;
}

export function parseLocalDate(dateStr) {
    if (!dateStr) return null;

    if (typeof dateStr === 'string') {
        const isoDate = dateStr.split('T')[0]; // pega só a parte da data
        const [year, month, day] = isoDate.split('-');
        if (!year || !month || !day) return null;
        return new Date(year, month - 1, day);
    }

    if (dateStr instanceof Date) {
        return dateStr;
    }

    return null;
}

export function formatLocalDate(date) {
    if (!date) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}




export const SaleStatus = {
    OPENING: 'OPENING',
    SENDING_THE_FILE: 'SENDING_THE_FILE',
    PRODUCTION: 'PRODUCTION',
    CONCLUDED: 'CONCLUDED',
    CANCELED: 'CANCELED'
};

export const statusTranslate = {
    ALL: { label: 'Todos', color: '#ffffff' },
    IN_PROGRESS: { label: 'Em andamento', color: '#ffffff' },
    OPENING: { label: 'Abertura', color: '#1E90FF' },
    SENDING_THE_FILE: { label: 'Enviando o arquivo', color: '#81c2ff' },
    PRODUCTION: { label: 'Produção', color: '#ecd98a' },
    CONCLUDED: { label: 'Concluído', color: 'rgba(52,168,52,0.73)' },
    CANCELED: { label: 'Cancelado', color: '#949494' }
};

export const renderSaleOptions = (disabledStatus) => {
    return Object.keys(SaleStatus).map(status => {
        const disabled = disabledStatus?.includes(status);
        return (
            <option style={{color: disabled ? '#FFFFFF' : undefined, backgroundColor: disabled ? '#989797' : '#FFFFFF'}}
                    key={status} value={status} disabled={disabled}>
                {statusTranslate[status].label}
            </option>);
    });
};

export const renderAutomotiveServiceOptions = (hideConcludedAndCanceledOptionsInAutomotiveServiceList) => {
    const automotiveServiceStatuses = ['OPENING', 'PRODUCTION', 'CONCLUDED', 'CANCELED'];
    return automotiveServiceStatuses.map(status => {
        const disabled = hideConcludedAndCanceledOptionsInAutomotiveServiceList && ['CONCLUDED', 'CANCELED'].includes(status);
        return (
            <option style={{color: disabled ? '#FFFFFF' : undefined, backgroundColor: disabled ? '#989797' : '#FFFFFF'}}
                    key={status} value={status} disabled={disabled}>
                {statusTranslate[status].label}
            </option>);
    });
};

export const PaymentCondition = {
    FULL_PAYMENT: 'FULL_PAYMENT',
    INSTALLMENT_PAYMENT: 'INSTALLMENT_PAYMENT',
    INSTALLMENT_WITH_DOWN_PAYMENT: 'INSTALLMENT_WITH_DOWN_PAYMENT'
};

export const paymentConditionTranslate = {
    FULL_PAYMENT: { label: 'À vista'},
    INSTALLMENT_PAYMENT: { label: 'A prazo'},
    INSTALLMENT_WITH_DOWN_PAYMENT: { label: 'A prazo com entrada'}
};

export const renderPaymentConditionOptions = () => {
    return Object.keys(PaymentCondition).map(paymentCondition => (
        <option key={paymentCondition} value={paymentCondition}>
            {paymentConditionTranslate[paymentCondition].label}
        </option>
    ));
};

export { UserPermission, CompanyPermission } from '../core/permissionCodes';
